import React, { FC } from 'react';

import { screenreaderOnlyInlineStyles } from '../../util/styles/screenreaderOnly';

import { getClassNames } from './SemanticHeading.styles.legacy';
import { SemanticHeadingProps } from './SemanticHeading.types';
import { useSemanticHeadingBaseLevelContext } from './hooks';

export type { SemanticHeadingProps };

type HeadingTagLevel = SemanticHeadingProps['level'] | 6;
type HeadingTagName = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const headingTagMap: Record<HeadingTagLevel, HeadingTagName> = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
};

const SemanticHeading: FC<SemanticHeadingProps> = ({ level, screenreaderOnly = false, children }) => {
  const baseLevel = useSemanticHeadingBaseLevelContext();
  const levelWithBaseline = (level + baseLevel) as HeadingTagLevel;
  const HeadingTagName = headingTagMap[levelWithBaseline];
  const classNames = getClassNames();
  const styles = screenreaderOnly ? screenreaderOnlyInlineStyles : undefined;

  return (
    <HeadingTagName className={classNames.semanticHeading} style={styles}>
      {children}
    </HeadingTagName>
  );
};

export default SemanticHeading;
